// src/firebase.js
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import 'firebase/storage'

const config = {
  apiKey: "AIzaSyAjT_RCY2uKE1OAglh15My4TqBgSklwITw",
  authDomain: "connected-tv-stv-player.firebaseapp.com",
  databaseURL: "https://connected-tv-stv-player.firebaseio.com",
  projectId: "connected-tv-stv-player",
  storageBucket: "connected-tv-stv-player.appspot.com",
  messagingSenderId: "8356578409",
  appId: "1:8356578409:web:1665b5fe748b94b4740ef8"
}

firebase.initializeApp(config)
export default firebase


// WEBPACK FOOTER //
// ./src/modules/Firebase.js